import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/Button';

export default function NotFound() {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-gray-100 px-4">
      <div className="text-center">
        <div className="text-8xl font-bold text-gray-200 mb-4">404</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Pagina non trovata
        </h1>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          La pagina che stai cercando non esiste o e stata spostata.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Torna alla home
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/listings">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Esplora annunci
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
